import * as React from "react";
import DocumentTitle from "react-document-title";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<{}, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <DocumentTitle title={"Ошибка - Mindset.Digital"}>
          <Paper>
            <Grid
              container
              alignContent={"center"}
              justify={"center"}
              style={{
                height: "400px",
              }}
            >
              <Grid item>
                <Typography variant={"h4"} color={"secondary"}>
                  Что-то пошло не так.
                  <br />
                  Попробуйте перезагрузить страницу.
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </DocumentTitle>
      );
    }
    return this.props.children;
  }
}
